import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles.css";

import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { sxPagination, sxPaginationContrast } from "../../../../assets/styles/CommonSxProps";
import LoadingApp from "../../../../components/LoadingApp";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { Evento } from "../../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Evento";
import { getEvents } from "../../../../services/SaudeBemEstar/PalestrasEventosService";
import { InvitationWarningCard } from "../InvitationWarningCard";
import { ConfirmedInvitationCard } from "./ConfirmedInvitationCard";
import { scrollTo } from "../../../../utils/ScrollUtil";
import PageTitle from "../../../../components/Accessibility/PageTitle";

export default function PalestrasEventosConfirmados() {
  const rowsPerPage = 5;

  const [events, setEvents] = React.useState<Evento[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [reload, setReload] = React.useState(false);

  const accessibility = useAccessibility();
  const navigate = useNavigate();
  const location = useLocation();

  const closeErrorModal = () => setOpenErrorModal(false);

  const reloadPage = () => {
    setReload(!reload)
  }

  React.useEffect(() => {
    setLoading(true);
    getEvents()
      .then((data) => {
        const sortedEvents = data.sort((a, b) => {
          const dateA = new Date(`${a.data.split('/').reverse().join('-')}T${a.hora}`).getTime();
          const dateB = new Date(`${b.data.split('/').reverse().join('-')}T${b.hora}`).getTime();
          return dateB - dateA;
        });
        setEvents(sortedEvents);
      })
      .catch(() => setOpenErrorModal(true))
      .finally(() => setLoading(false));
  }, [reload]);

  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = page * rowsPerPage;

  const invitationElements = events?.slice(startIndex, endIndex)?.map((event, index) => {
    return <ConfirmedInvitationCard reloadPage={reloadPage} evento={event} key={index + startIndex} />;
  });

  return (
    <div className="palestras-eventos-content">
      <PageTitle text="Confirmados" />
      {!loading && !events?.length && (
        <div>
          <Typography style={accessibility.textStyleAccessibilityWithMargin}>Você não possui nenhum evento confirmado.</Typography>
          <Typography style={accessibility.textStyleAccessibility}>Quando você confirmar sua presença em palestras ou eventos, eles aparecerão aqui.</Typography>
        </div>
      )}
      {!loading && !!events?.length && <InvitationWarningCard title="ATENÇÃO:" message="Caso não possa comparecer, lembre-se de cancelar a sua presença com antecedência" />}
      {!loading && invitationElements}
      {events?.length > rowsPerPage && (
        <Pagination
          count={Math.ceil(events.length / rowsPerPage)}
          sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination}
          hideNextButton
          hidePrevButton
          color="primary"
          page={page}
          onChange={(_, newPage) => {
            setPage(newPage);
            scrollTo('scroll-ref');
          }}
        />
      )}
      <button 
      style={accessibility.textStyleAccessibility} 
      className="back-button" 
      aria-label="Voltar para menu Palestras e eventos" 
      onClick={() => {
        const currentPath = location.pathname;
        const newPath = currentPath.replace("/confirmados", "");
        navigate(newPath);
      }}>
        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />
        &nbsp;&nbsp;<u>Voltar</u>
      </button>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={openErrorModal}
        handleShowModal={closeErrorModal}
        handleButtonModal={closeErrorModal}
        icon="error"
        title="Erro"
        subTitle="Ocorreu um erro. Tente novamente em instantes."
        textButton="Fechar"
        showButtonModal
      />
    </div>
  );
}
